import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import TaxationAccountDetails from "../../../../containers/Accounts/TaxationAccount/TaxationAccountDetails";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";

function TaxAccountDetailsPopup({
  closeBeneAccountDetailModal,
  tax_account_id,
  type,
  headerTitle,
  headersubtext,
}) {
  const navigate = useNavigate();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <LargePopupRedirect
        headerTitle={headerTitle}
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        headertextSize="font-md"
        headersubtext={headersubtext}
        isfullViewrequired={true}
        fullviewbtnText="Open in full view"
        fullviewbtnType="button"
        fullviewhandleFunction={() => {
          closeBeneAccountDetailModal();
          navigate(
            `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/${tax_account_id}`,
          );
        }}
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        fullviewdisabledBgColor="var(--text-disabled)"
        closeiconbtnType="button"
        closeiconhandleFunction={closeBeneAccountDetailModal}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
      >
        <TaxationAccountDetails
          tax_account_id={tax_account_id}
          closeBeneAccountDetailModal={closeBeneAccountDetailModal}
          type={type}
        />
      </LargePopupRedirect>
    </div>
  );
}

export default TaxAccountDetailsPopup;
